import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getHomeData = () => {
  return axios.get('/home');
};

export const useHomeData = ({ config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ['home_data'],
    queryFn: () => getHomeData(),
  });
};
